import {MiniCartController} from '@wc-stripe/controllers';
import {getSetting} from '@wc-stripe/utils';
import Context from '@wc-stripe/context';
import {ApplePayGateway} from '@wc-stripe/gateways'

const settings = getSetting('stripe_applepay_data');

const context = new Context('minicart');

const gateway = new ApplePayGateway({
    id: 'stripe_applepay',
    settings,
    context
});

const controller = new MiniCartController({
    context,
    gateway,
    selector: 'a.wc-stripe_applepay-mini-cart'
});

controller.initialize();